import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const JobListService = {
  getList: async () => {
    const response = await apiService.get("/joblistings",{
      params: {
        page: 1,
        pageSize: 20,
      },
    });
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/joblistings/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(
      `/organizationtimeline/slug?slug=${id}`
    );
    return response.data;
  },
};

export default JobListService;
